import { Card } from 'antd';
import React from 'react';
import { MODULES } from '../../../common/constants';
import Portal from '../../../components/Portal';
import ConfigTable from '../components/ConfigTable';

const Configs = () => (
  <>
    <Portal portalId="header-title-content">
      <div className="portal-header">{MODULES?.CONFIGS}</div>
    </Portal>
    <Card className="full-height-without-nav">
      <ConfigTable />
    </Card>
  </>
);

export default Configs;
